/** Bandeau signature : 3 segments aux couleurs des étapes, en haut des pages mobiles et dans le logo. */
export function BandeauSignature({ petit = false }: { petit?: boolean }) {
  return (
    <div className={petit ? 'bandeau-signature petit' : 'bandeau-signature'} aria-hidden="true">
      <span />
      <span />
      <span />
    </div>
  );
}
